import AuthCookieProvider from './AuthCookieProvider';

export default AuthCookieProvider;
